<template>
  <select class="selector" v-model="selected">
    <option disabled value="">Please select one</option>
    <option v-for="(option, index) in options" :key="index" :value="option.value || option">
      {{ option.label || option }}
    </option>
  </select>
</template>

<script>
export default {
  name: "Select",
  props: {
    currentSelection: {
      type: [String, Number],
    },
    options: Array,
  },
  methods: {
    select(newValue) {
      this.$emit("selected", newValue);
    },
  },
  computed: {
    selected: {
      get() {
        return this.currentSelection;
      },
      set(newValue) {
        this.select(newValue);
      },
    },
  },
};
</script>

<style>
.selector {
  background-color: #fff;
  border-radius: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
  outline: none;
  height: 40px;
  box-sizing: border-box;
  font-weight: 600;
  border-color: transparent;
  font-size: 18px;
  box-shadow: 0 1px 4px 0 rgb(206 206 206 / 42%) !important;
  font-family: "Nunito";
  padding-left: 16px;
  padding-right: 16px;
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  /* overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 7px; */
  width: 220px;
}
.selector:hover {
  background-color: #e8e8e8;
}
</style>
